const editModes = {
	pan: false,
	move: false,
	selectedNode: undefined as any
}

export default editModes